"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.imgGen.name': '图像生成',
    'tools.imgGen.description': '从文字描述生成图像',
};
